import { BroadcastChannel as BroadcastChannelImpl } from "broadcast-channel";
import * as devalue from "devalue";
export function useVoixBroadcast() {
  const share = (channelName, store, type = "native") => {
    if (typeof window === "undefined")
      return;
    if (!window.location.search.includes("voix-sync") && !window.location.pathname.includes("voix/studio")) {
      return;
    }
    const channel = new BroadcastChannelImpl(channelName, { type });
    channel.postMessage({
      state: devalue.parse(devalue.stringify(store))
    });
    return channel;
  };
  const receive = (channelName, callback, type = "native") => {
    if (typeof window === "undefined")
      return;
    if (!window.location.search.includes("voix-sync") && !window.location.pathname.includes("voix/studio")) {
      return;
    }
    const channel = new BroadcastChannelImpl(channelName, { type });
    channel.onmessage = (evt) => {
      callback(evt.state);
    };
  };
  return { share, receive };
}
